import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/react-hooks';
import { kmsClient } from '../../apollo';
import {
  ArticlesWithInstantMessage,
  ArticlesWithInstantMessageVariables
} from './__generated__/ArticlesWithInstantMessage';

const ARTICLES_INSTANT_MESSAGE_QUERY = gql`
  query ArticlesWithInstantMessage($filter: AllArticlesFilterInput) {
    allArticles(filter: $filter) {
      edges {
        node {
          id
          instantArticleMessage
        }
      }
    }
  }
`;

export const useArticlesWithInstantMessage = () => {
  return useLazyQuery<ArticlesWithInstantMessage, ArticlesWithInstantMessageVariables>(ARTICLES_INSTANT_MESSAGE_QUERY, {
    client: kmsClient,
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true
  });
};
